export default __webpack_public_path__ + "static/Layer5-HashiCorp-Service-Mesh-Partnership-1f62538bd0a0f4a38138a9bcaccf3e8a.webp";